
import React from 'react';

// Components

import BlockWrapper from './BlockWrapper';


const ReduxStoreInfo = props => {

    let {
        id,
        storeData
    } = props;

    storeData = {
        ...storeData,
        common: {
            ...storeData.common,
            messages: 'Messages are skipped'
        },
        ssap: {
            ...storeData.ssap,
            countries: 'Countries are skipped'
        }
    };

    const getStoreRepresentation = () => <pre>{ JSON.stringify(storeData, null, 4) }</pre>;

    return (
        <BlockWrapper id={id} additionalStyles={{ overflowY: 'auto', height: '600px' }}>
            { getStoreRepresentation() }
        </BlockWrapper>
    );

};

export default ReduxStoreInfo;